import type { NextSeoProps } from 'next-seo/pages';

import { buildOpenGraphObject } from './buildOpenGraphObject';

type BuildContentPageSeoConfigInput = {
	description?: string | null;
	image?: string | null;
	imageAlt?: string | null;
	imageHeight?: number | null;
	imageWidth?: number | null;
	title?: string | null;
	url?: string | null;
};

export function buildContentPageSeoConfig({
	description,
	image,
	imageAlt,
	imageHeight,
	imageWidth,
	title,
	url,
}: BuildContentPageSeoConfigInput): NextSeoProps {
	const openGraph = buildOpenGraphObject({ description, image, imageAlt, imageHeight, imageWidth, title, url });

	// Misc
	const canonical = url;

	return { canonical: canonical || undefined, description: description || undefined, openGraph, title: title || undefined };
}
